import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    customers: [],
    customers_filter: {},
    customers_pagination_limit: 10,
    customers_pagination: {},
    rfm_counts: {},
    customer: {},
  },
  mutations,
  actions,
  getters,
};
